import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import CookiesSubModal from './DetailToogle'
import { CookieDetail } from '@/app/types/cookieConsentType'

interface CookieToggleProps {
  title?: string
  isOpen: boolean
  onToggle: () => void
  description: string
  additionalContent: React.ReactNode
  SubCookieDetails?: CookieDetail[]
  needToogle?: boolean
}
const CookieToggle: React.FC<CookieToggleProps> = ({
  title,
  isOpen,
  onToggle,
  description,
  additionalContent,
  needToogle = true,
  SubCookieDetails,
}) => {
  return (
    <>
      <div className="flex flex-col border gap-1 rounded-md  pb-2 mt-[12px]">
        <div className="flex bg-[#F3F5F6] items-center  justify-between h-11 rounded-md px-1 pt-1  mb-[16px]  ">
          {title && (
            <label className="flex  cursor-pointer" onClick={onToggle}>
              {needToogle && (
                <span>
                  {isOpen ? (
                    <ExpandLessIcon className="text-[#6b6b6b]" />
                  ) : (
                    <ExpandMoreIcon className="text-[#6b6b6b]" />
                  )}
                </span>
              )}
              <p className="font-normal not-italic leading-[1.63] tracking-[0.05px] ml-1 text-left text-base">
                {title}
              </p>
            </label>
          )}
          {additionalContent}
        </div>
        <div className="ml-5 mr-[57px]">
          <p className="text-sm line-sp font-normal not-italic leading-[1.4] tracking-[0.04px]  text-left text-[#8b8b8b]">
            {description}
          </p>
        </div>
        {needToogle && isOpen && (
          <CookiesSubModal cookieDetails={SubCookieDetails} />
        )}
      </div>
    </>
  )
}

export default CookieToggle
